import React, { useEffect } from "react"
import Helmet from "react-helmet"
import HomepageLayout from "src/layouts/homepage"
import JSONData from "branding/site-metadata.json"
import RawFooter from "@tightrope/footerlinks/rawfooter.js"
import "./tos.css"; // Import CSS file here


export default function Terms() {
  useEffect(() => {
      const script = document.createElement("script");
      script.src = "https://app.termly.io/embed-policy.min.js";
      script.async = true;
      document.body.appendChild(script);
  }, []);

    return (
        <HomepageLayout>
            <Helmet data={JSONData}><title>Terms of Service</title></Helmet>
            <header>
                <img src="/img/logo.png" alt="Easyview Logo" />
            </header>
            <main className="content-wrapper">
                <div className="container">
                    <div
                        name="termly-embed"
                        data-id="a9f19a70-f043-40d3-83f7-bced9d956862"
                        data-type="iframe"
                    ></div>
                </div>
            </main>
            <RawFooter />
        </HomepageLayout>
    );
}
